module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/view-order/view-order.component.css
// module id = ./src/app/admin/view-order/view-order.component.css
// module chunks = main